import classNames from 'classnames';
import React, { PropsWithChildren, SVGProps } from 'react';
import { useStrip } from '../hooks/useStrip';
import { useSelector } from 'react-redux';
import { roundedDurationSelector } from '../../ecg/selectors/ecg.selectors';

export type ClipTypes = 'default' | 'all' | 'horizontal' | 'vertical' | 'plot';

type Props = PropsWithChildren<SVGProps<SVGSVGElement>> & {
  clipType?: ClipTypes;
};

export const StripContent: React.FC<Props> = ({
  clipType = 'default',
  className = '',
  children,
  ...svgProps
}) => {
  const ecgDuration = useSelector(roundedDurationSelector);
  const { x, y, height, width, xScale, onset, offset } = useStrip();
  const duration = xScale(ecgDuration);
  const scaledOnset = xScale(onset);
  const scaledOffset = xScale(offset);
  const totalDuration = duration + scaledOffset + scaledOnset;

  switch (clipType) {
    case 'plot':
      return (
        <svg
          {...svgProps}
          className={classNames(className, `content-${clipType}`)}
          width={totalDuration}
          height={height}
        >
          {children}
        </svg>
      );
    case 'vertical':
      return (
        <svg
          {...svgProps}
          className={classNames(className, `content-${clipType}`)}
          width={width}
          height='200%'
          y='-100%'
        >
          <g style={{ transform: `translate(0, 50%)` }}>{children}</g>
        </svg>
      );
    case 'horizontal':
      return (
        <svg
          {...svgProps}
          className={classNames(className, `content-${clipType}`)}
          width='200%'
          height={height}
          x='-100%'
        >
          <g style={{ transform: `translate(50%, 0)` }}>{children}</g>
        </svg>
      );
    case 'all':
      return (
        <svg
          {...svgProps}
          className={classNames(className, `content-${clipType}`)}
          width={width}
          height={height}
          x={x}
          y={y}
        >
          {children}
        </svg>
      );
    case 'default':
    default:
      return (
        <svg
          {...svgProps}
          className={classNames(className, `content-${clipType}`)}
          width={width}
          height={height}
        >
          {children}
        </svg>
      );
  }
};
